


































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class UiKitNewWindowLink extends Vue {
  @Prop() public name: string;
  @Prop() public title: string;
  @Prop({ default: 535 }) public width: number | string;
  @Prop({ default: 'auto' }) public height: number | string;

  protected onOpen() {
    document.body.style.overflow = 'hidden';

    const closeButton = document.getElementById('close-button');

    if (!closeButton) {
      return;
    }

    closeButton.focus();
  }

  protected onClose() {
    document.body.style.overflow = 'auto';
  }
}
